$(document).ready(function() {
  // Überprüfe die Gerätebreite und zeige die Produktbeschreibung an, wenn sie breiter als 900px ist
  if ($(window).width() >= 990) {
    $(".collapsible-content__description").show();
    $(".collapsible-content__arrow").toggleClass("expanded");
  }

  // Attach click event to accordion trigger
  $("#description-toggle").click(function() {
    // Toggle the visibility of the content
    $(".collapsible-content__description").slideToggle(200);

    $(".collapsible-content__arrow").toggleClass("expanded");
  });
});